import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * shadcn/ui convention: merge Tailwind classes, de-duplicating conflicts.
 * Use at every shadcn component boundary: `<Comp className={cn("base", props.className)}>`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
